/**
 * VendorLogService
 * Service for managing vendor logs
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor log CRUD operations with vendor-specific queries
 */
export class VendorLogService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorLogService.DEFAULT_SERVICE_PATH,
            basePath: VendorLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all logs for a specific vendor
     * @param vendorId - The vendor ID
     * @returns Array of vendor log views
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all logs for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of vendor log views
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
    /**
     * Get all log model views for a specific vendor (enriched with user info)
     * @param vendorId - The vendor ID
     * @returns Array of vendor log model views
     */
    async getViewsByVendor(vendorId) {
        const response = await this.getViewsByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all log model views for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of vendor log model views
     */
    getViewsByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}/views`);
        return this.http.get(url);
    }
}
VendorLogService.DEFAULT_SERVICE_PATH = 'vendors';
VendorLogService.BASE_PATH = 'api/vendor-logs';
//# sourceMappingURL=VendorLogService.js.map